




















import Vue, { PropType } from "vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    popup: Object as PropType<Popup>,
  },
  computed: {
    id() {
      const { popup } = this;
      const { id } = popup;
      return id;
    },
    title() {
      const { popup } = this;
      const { title } = popup;
      return title;
    },
    content() {
      const { popup } = this;
      const { content } = popup;
      return content;
    },
    image() {
      const { popup } = this;
      const { image } = popup;
      const { url } = image;
      return url;
    },
    buttonText() {
      const { popup } = this;
      const { button_text } = popup;
      return button_text;
    },
    buttonUrl() {
      const { popup } = this;
      const { button_url } = popup;
      return button_url;
    },
    page() {
      const { popup } = this;
      const { page } = popup;
      return page[0];
    },
    target() {
      const { popup } = this;
      const { target } = popup;
      return target[0];
    },
    enabledNavigationButton() {
      const { buttonText, buttonUrl } = this;
      return buttonText && buttonUrl;
    },
  },
  methods: {
    onPositiveClick() {
      const { buttonUrl } = this;
      window.open(buttonUrl);
      this.$close(true);
    },
    onClickOutSide() {
      this.$close(true);
    },
    onClickClose() {
      this.$close(true);
    },
  },
});

interface Props {
  popup: Popup;
}

interface Data {}

interface Computed {
  id: string;
  title: string;
  content: string;
  image: string;
  buttonText: string;
  buttonUrl: string;
  page: string;
  target: Target;
  enabledNavigationButton: boolean;
}

interface Methods {
  onPositiveClick: () => void;
  onClickOutSide: () => void;
  onClickClose: () => void;
}

export type PopupDialogProps = Props;

export type Popup = {
  id: string;
  title: string;
  content: string;
  image: {
    url: string;
  };
  button_text: string;
  button_url: string;
  page: string[];
  target: Target[];
};

type Target = "all" | "free" | "premium";
